<!-- 客户服务统计 -->
<template>
    <div id="customerCount" class="business-content-main">
        <div class="bread-nav">
            <div>您当前位置：</div>
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>客服</el-breadcrumb-item>
                <el-breadcrumb-item>数据统计</el-breadcrumb-item>
                <el-breadcrumb-item>客户服务统计</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="search-ctn">
            <div class="search-name">时间:</div>
            <el-date-picker
                    :picker-options="startDateOps"
                    class="search-item"
                    v-model="searchData.StartDate"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    type="date"
                    size="small"
                    placeholder="选择日期">
            </el-date-picker>
            <span class="search-name">至</span>
            <el-date-picker
                    :picker-options="endDateOps"
                    class="search-item"
                    v-model="searchData.EndDate"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    type="date"
                    size="small"
                    placeholder="选择日期">
            </el-date-picker>
            <div class="search-name">客服组:</div>
            <div class="search-item goods-categories">
                <el-input
                        size="small"
                        readonly
                        v-model="groupName"
                        @click.stop.native="showCategories()"
                        placeholder="请输选择客服组">
                </el-input>
                <div class="categories-tree" v-show="categoriesShow">
                    <serviceGroup @chooseNode="chooseNode"></serviceGroup>
                </div>
            </div>
            <div class="search-name">客服人员:</div>
            <el-select
                    size="small"
                    class="search-item"
                    v-model="searchData.SId"
                    placeholder="请选择">
                <el-option
                        v-for="item in services"
                        :label="item.Name"
                        :value="item.Id">
                </el-option>
            </el-select>
            <el-button type="primary" size="small" icon="el-icon-search" class="search-btn" @click="handleSearch">查询</el-button>
            <el-button type="primary" size="small" icon="el-icon-refresh" class="search-btn" @click="resetSearch">重置</el-button>
        </div>
        <div class="table-ctn">
            <el-table
                    :header-cell-style="{background:'#F2F6FC'}"
                    :data="tableData"
                    border
                    style="width: 100%">
                <el-table-column
                        show-overflow-tooltip
                        prop="CustomerCount"
                        label="访客总量">
                </el-table-column>
                <el-table-column
                        show-overflow-tooltip
                        prop="InquirySheet"
                        label="发起询价单总量">
                </el-table-column>
                <el-table-column
                        show-overflow-tooltip
                        prop="OrderConversionCount"
                        label="转化订单总量">
                </el-table-column>
                <el-table-column
                        show-overflow-tooltip
                        prop="OrderQuantityCount"
                        label="成交订单总量">
                </el-table-column>
                <el-table-column
                        show-overflow-tooltip
                        prop="Turnover"
                        label="成交金额总计">
                </el-table-column>
                <el-table-column
                        show-overflow-tooltip
                        prop="SName"
                        label="客服人员">
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination-ctn">
            <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="searchData.page"
                    :page-sizes="[10, 20, 30, 40, 50]"
                    :page-size="searchData.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength">
            </el-pagination>
        </div>
    </div>
</template>
<script>
    import serviceGroup from '@/components/common/serviceGroup.vue'
    export default {
        name: 'team',
        components: {
            serviceGroup
        },
        data() {
            return {
                startDateOps: {
                    disabledDate: (time) => {
                        if (this.searchData.EndDate != "") {
                            return  time.getTime() > new Date(this.searchData.EndDate);
                        }

                    }
                },
                endDateOps: {
                    disabledDate: (time) => {
                        if (this.searchData.StartDate != "") {
                            return  time.getTime() < new Date(this.searchData.StartDate);
                        }

                    }
                },
                groupName:'',
                services:[],
                categoriesShow:false,
                searchData: {
                    SId:'',
                    StartDate:'',
                    EndDate:'',
                    GroupId:'',
                    page:1, // 当前页数
                    limit:10, // 每页限制条数
                },
                tableData: [],
                tableDataLength:0,
            }
        },
        mounted() {
            this.getTableData()
            window.onclick = ()=>{
                this.categoriesShow = false
            }
        },
        methods: {
            showCategories(){
                this.categoriesShow = true
            },
            // 选中客服组分类
            chooseNode(data){
                if (data){
                    this.searchData.GroupId = data.Item.Id
                    this.groupName = data.Item.Name
                    this.getServicesByGId(data.Item.Id)
                }
                else {
                    this.searchData.GroupId = ''
                    this.groupName = ''
                }
                this.categoriesShow = false
            },
            // 加载客服团队列表
            getTableData(){
                this.axios.get('/Statistics/LoadServiceStatistics',{
                    params: this.searchData

                })
                    .then((response)=> {
                        this.tableData = response.data.data
                        this.tableDataLength = response.data.count
                    })
                    .catch((error)=>{
                        console.log(error);
                    });
            },
            //  根据客服组ID获取所有在职客服
            getServicesByGId(gId){
                this.$util.GetServicesByGId(gId).then(value => {
                    this.services = value
                    this.searchData.Id = ''
                })
            },
            handleSearch(){
                this.searchData.page = 1
                this.getTableData()
            },
            resetSearch(){
                this.searchData = {
                    SId:this.$store.state.userMsg.Id,
                    StartDate:'',
                    EndDate:'',
                    GroupId:'',
                    page:1, // 当前页数
                    limit:10, // 每页限制条数
                }
                this.groupName =''
            },
            handleSizeChange(val) {
                this.searchData.limit = val
                this.getTableData()
            },
            handleCurrentChange(val) {
                this.searchData.page = val
                this.getTableData()
            }
        }
    }
</script>
<style lang="less" scoped>

</style>
